(function (global, $, Si) {
    "use strict";

    Si.when('SidePanel', 'PlayerStatModal').then(matchPreviewPage);

    function matchPreviewPage(SidePanel, PlayerStatModal) {

        var panelAnchor = $('.side-panel-trigger');
        var containerElement = $('body');
        var openerElement = $('.opener');

        SidePanel.initSidePanel(panelAnchor, containerElement, openerElement);
        PlayerStatModal.initPlayerStatModal(
            '[data-stat-modal]',
            '.player-modal-link',
            '[data-season-link]',
            '[data-team-link]',
            '[data-table]'
        );
    }

})(window, jQuery, Si);